itsoftApp.createModule("disclaimer", ["pageLoad", "cookie"], function () {
    const module = this;
    const bodyEnd = document.querySelector(".js-padding-bottom");

    const Disclaimer = function () {
        this.scrollTriggerElement = null;
        this.disclaimerWrapper = document.querySelector(".js-disclaimer-wrapper");
        this.scrollSmootherUsed = false;
        this.disclaimerPosition = null; /* сохраняем сюда элемент, где визуально должен находиться дисклеймер в состоянии static или inactive; пока не используется */
        this.footer = document.querySelector(".page-footer");
        this.disclaimer = document.querySelector(".js-disclaimer"); /* У дисклеймера должен быть такой класс */
        this.state = "static";
        this.gap = 0;
        this.cookies = document.querySelector(".js-cookies");
        this.button = document.querySelector(".disclaimer__close-button"); /* Крестик */
        this.confirm = document.querySelector(".disclaimer__confirm"); /* элемент подтвеждения закрытия */
        this.text = document.querySelector(".disclaimer__text");
        this.disclaimerParts = document.querySelectorAll(".disclaimer__part");
        this.footerCoordY;
        this.sTop;
        this.requiredPercentage = 8;

        if (this.disclaimer) {
            this.init();
            this.onScroll = this.onDocumentScroll.bind(this);
            this.onResize = this.onDocumentResize.bind(this);
        }
    };

    Disclaimer.prototype.buttonMouseOver = function () {
        const DISCLAIMER = this;
        if (!this.disclaimer.classList.contains("js-hover")) {
            this.disclaimer.classList.add("js-hover");
            if (this.confirm) {
                this.confirm.addEventListener("mouseleave", DISCLAIMER.buttonMouseOut.bind(DISCLAIMER));
            }
        }
    };

    Disclaimer.prototype.buttonMouseOut = function () {
        const DISCLAIMER = this;
        this.disclaimer.classList.remove("js-hover");
        this.confirm.removeEventListener("mouseleave", DISCLAIMER.buttonMouseOut.bind(DISCLAIMER));
    };

    Disclaimer.prototype.close = function () {
        const DISCLAIMER = this;
        itsoftApp.modules.cookie.setCookie(DISCLAIMER.disclaimer);
        this.state = "static";
        this.disclaimer.classList.add("js-static");
        this.disclaimer.classList.add("js-inactive");
        if (this.disclaimer.classList.contains("js-hover")) {
            this.disclaimer.classList.remove("js-hover");
        }
        if (this.confirm) {
            this.confirm.style.display = "none";
        }
        if (this.disclaimerWrapper) {
            this.disclaimerWrapper.appendChild(this.disclaimer);
        }
        this.footer.classList.add("js-update");

        if (!DISCLAIMER.scrollSmootherUsed) {
            document.removeEventListener("scroll", DISCLAIMER.onScroll);
        }

        window.removeEventListener("resize", DISCLAIMER.onResize);

        if (DISCLAIMER.cookies) {
            DISCLAIMER.cookies.style.bottom = 0;
        }

        if (bodyEnd) {
            bodyEnd.style.paddingBottom = 0;
        }
    };

    Disclaimer.prototype.checkButton = function () {
        const DISCLAIMER = this;
        if (DISCLAIMER.button) {
            DISCLAIMER.button.addEventListener("mouseover", DISCLAIMER.buttonMouseOver.bind(DISCLAIMER));

            DISCLAIMER.button.addEventListener("click", function (evt) {
                evt.preventDefault();
                this.close = DISCLAIMER.close();
            });
        }
    };

    Disclaimer.prototype.checkConfirm = function () {
        const DISCLAIMER = this;
        if (DISCLAIMER.confirm) {
            DISCLAIMER.confirm.addEventListener("click", function (evt) {
                evt.preventDefault();
                this.close = DISCLAIMER.close();
            });
        }
    };

    Disclaimer.prototype.defineCoordY = function () {
        const DISCLAIMER = this;
        DISCLAIMER.footerCoordY = DISCLAIMER.footer.getBoundingClientRect().top + pageYOffset;
    };

    /* Вычисляем координаты. Если мы прокрутили страницу до подвала, делаем дисклеймер статичным */
    Disclaimer.prototype.checkElementCoords = function () {
        const DISCLAIMER = this;
        let reVerified = false;
        this.sTop = pageYOffset;

        if (this.sTop > 200 && !reVerified) { // изредка неправильно определяет координаты сразу после полной загрузки страницы, поэтом нужна одна доп. проверка
            reVerified = true;
            DISCLAIMER.defineCoordY();
        }

        if (this.sTop + document.documentElement.clientHeight > this.footerCoordY) {
            if (this.disclaimerWrapper) {
                this.disclaimerWrapper.appendChild(this.disclaimer);
                DISCLAIMER.defineCoordY();
            }

            if (DISCLAIMER.state != "inactive") {
                DISCLAIMER.state = "inactive";

                // if (bodyEnd) {
                //     bodyEnd.style.paddingBottom = 0;
                // }
            }

            if (this.button) {
                this.button.classList.add("js-close-hide");
            }
            if (this.confirm) {
                this.confirm.style.display = "none";
            }
            this.disclaimer.classList.add("js-inactive");
            if (DISCLAIMER.cookies) {
                DISCLAIMER.cookies.style.bottom = 0;
            }
        } else if (!this.disclaimer.classList.contains("js-static")) {
            if (this.disclaimerWrapper) {
                document.body.appendChild(this.disclaimer);
                DISCLAIMER.defineCoordY();
            }

            if (DISCLAIMER.state != "active") {
                DISCLAIMER.state = "active";

                // if (!itsoftApp.state.сheckListElementsToBeUpdatedDuringResizing.disclaimerHeight) {
                //     itsoftApp.state.сheckListElementsToBeUpdatedDuringResizing.disclaimerHeight = true;
                //     itsoftApp.calculations.disclaimerHeight = itsoftApp.utils.getDisclaimerHeight();
                // }

                // if (bodyEnd) {
                //     bodyEnd.style.paddingBottom = itsoftApp.calculations.disclaimerHeight + "px";
                // }
            }

            if (this.button) {
                this.button.classList.remove("js-close-hide");
            }
            if (this.confirm) {
                this.confirm.style.display = "";
            }
            this.disclaimer.classList.remove("js-inactive");
            if (DISCLAIMER.cookies) {
                DISCLAIMER.height = itsoftApp.calculations.disclaimerHeight;
                DISCLAIMER.disclaimer.style.bottom = DISCLAIMER.cookies.clientHeight + DISCLAIMER.gap + "px";
            }
        }
    };

    Disclaimer.prototype.onDocumentScroll = function () {
        const DISCLAIMER = this;
        DISCLAIMER.checkElementCoords();
    };

    Disclaimer.prototype.onDocumentResize = function () {
        /* Обновляем координаты при ресайзе */
        const DISCLAIMER = this;
        DISCLAIMER.calcFontSize();
        DISCLAIMER.defineCoordY();
        if (DISCLAIMER.cookies) {
            /* todo: доработать, достать из itsoftApp.calculations.disclaimerHeight */
            DISCLAIMER.height = DISCLAIMER.disclaimer.getBoundingClientRect().height;
            DISCLAIMER.disclaimer.style.bottom = DISCLAIMER.cookies.clientHeight + DISCLAIMER.gap + "px";
        }
        
        DISCLAIMER.checkElementCoords();
    };

    Disclaimer.prototype.init = function () {
        const DISCLAIMER = this;
        if (DISCLAIMER.disclaimer.hasAttribute("data-always-active-on-mobile")) {
            DISCLAIMER.alwaysActiveOnMobile = true;
        }

        if (DISCLAIMER.disclaimer) {
            /* Инициализируем модуль после полной загрузки страницы, только если на странице есть дисклеймер */
            itsoftApp.modules.pageLoad.addEvent(function () {
                if (DISCLAIMER.disclaimerWrapper) {
                    DISCLAIMER.disclaimerPosition = DISCLAIMER.disclaimerWrapper;
                } else {
                    DISCLAIMER.disclaimerPosition = DISCLAIMER.disclaimer;
                }

                DISCLAIMER.calcFontSize();

                DISCLAIMER.dAttrSave = DISCLAIMER.disclaimer.getAttribute("data-save");

                if (!DISCLAIMER.dAttrSave || (DISCLAIMER.dAttrSave && !itsoftApp.modules.cookie.getCookie(DISCLAIMER.disclaimer))) {
                    DISCLAIMER.defineCoordY();
                    itsoftApp.state.сheckListElementsToBeUpdatedDuringResizing.disclaimerHeight = true;
                    itsoftApp.calculations.disclaimerHeight = itsoftApp.utils.getDisclaimerHeight();
                    DISCLAIMER.checkElementCoords();
                } else {
                    DISCLAIMER.state = "static";
                    if (DISCLAIMER.disclaimerWrapper) {
                        DISCLAIMER.disclaimerWrapper.appendChild(DISCLAIMER.disclaimer);
                        DISCLAIMER.defineCoordY();
                    }
                    return;
                }

                if (DISCLAIMER.sTop + document.documentElement.clientHeight > DISCLAIMER.footerCoordY) {
                    DISCLAIMER.state = "inactive";
                } else {
                    DISCLAIMER.state = "active";
                }

                if (bodyEnd && DISCLAIMER.alwaysActiveOnMobile) {
                    if (!itsoftApp.state.сheckListElementsToBeUpdatedDuringResizing.disclaimerHeight) {
                        itsoftApp.state.сheckListElementsToBeUpdatedDuringResizing.disclaimerHeight = true;
                        itsoftApp.calculations.disclaimerHeight = itsoftApp.utils.getDisclaimerHeight();
                    }

                    bodyEnd.style.paddingBottom = itsoftApp.calculations.disclaimerHeight + "px";
                }

                if (DISCLAIMER.disclaimerWrapper) {
                    DISCLAIMER.height = DISCLAIMER.disclaimer.getBoundingClientRect().height;
                    DISCLAIMER.disclaimerWrapper.style.height = DISCLAIMER.height + "px";
                }

                if (DISCLAIMER.cookies && DISCLAIMER.state == "active") {
                    DISCLAIMER.disclaimer.style.bottom = DISCLAIMER.cookies.clientHeight + DISCLAIMER.gap + "px";
                }


                document.addEventListener("scroll", DISCLAIMER.onScroll, {passive: true});
                /* todo: доработать, достать из itsoftApp.calculations.disclaimerHeight */
                window.addEventListener("resize", DISCLAIMER.onResize);

                DISCLAIMER.onDocumentResize();
            });

            DISCLAIMER.checkButton();
            DISCLAIMER.checkConfirm();
        }
    };

    Disclaimer.prototype.getWordsSquare = function () {
        let square = 0;

        Array.prototype.forEach.call(this.disclaimerParts, function (word) {
            const blockW = word.clientWidth;
            const blockH = word.clientHeight;
            const currentSquare = blockW * blockH;
            square += currentSquare;
        });

        return square;
    };

    Disclaimer.prototype.getWindowSquare = function () {
        const bodyWidth = itsoftApp.utils.getViewportSize();
        const bodyHeight = itsoftApp.utils.getViewportHeight();
        return bodyWidth * bodyHeight;
    };

    Disclaimer.prototype.getFinalValue = function (square) {
        const percent = square * 100 / this.getWindowSquare();
        return percent > this.requiredPercentage;
    };

    Disclaimer.prototype.setFontSize = function (size) {
        this.text.style.fontSize = size + "px";
        this.text.setAttribute("data-font-size", size);
    };

    Disclaimer.prototype.getFontSize = function () {
        return parseInt(this.text.getAttribute("data-font-size"), 10) || 8;
    };

    Disclaimer.prototype.calcFontSize = function () {
        const DISCLAIMER = this;
        let counter = 0;
        if (window.innerWidth > 1023) {
            DISCLAIMER.setFontSize(32);
        } else {
            DISCLAIMER.setFontSize(22);
        }

        while (this.getFinalValue(this.getWordsSquare(), this.requiredPercentage) === false) {
            if ( counter++ > 100 ) {
                break
            };

            if (window.innerWidth > 1023 && DISCLAIMER.text.clientHeight > DISCLAIMER.disclaimerParts[0].clientHeight) {
                DISCLAIMER.setFontSize(DISCLAIMER.getFontSize() - 3);
                break;
            }

            if (window.innerWidth <= 1023 && DISCLAIMER.text.clientHeight > DISCLAIMER.disclaimerParts[0].clientHeight * 2) {
                DISCLAIMER.setFontSize(DISCLAIMER.getFontSize() - 2);
                break;
            }

            DISCLAIMER.setFontSize(DISCLAIMER.getFontSize() + 2);
        }
        const fontSize = this.getFontSize();
        this.text.style.fontSize = fontSize + "px";
    };

    window.DISCLAIMER = new Disclaimer();
    module.callback = Disclaimer;
});
